import { useMutation, useQueryClient } from "@tanstack/react-query";

import api, { ApiCatalog } from "@/api";
import { userClassroomsQueries } from "@/classrooms/queries";

interface UseGenerateClassCodeOptions {
  classroomUniqueId: string | null | undefined;
  existingClassCode?: string | null;
}

interface RegenerateCodeResponse {
  class_code: string;
}

const useGenerateClassCode = ({
  classroomUniqueId,
  existingClassCode = null,
}: UseGenerateClassCodeOptions) => {
  const queryClient = useQueryClient();

  const { mutate, isPending, isError, error, data } = useMutation({
    mutationFn: () => {
      if (!classroomUniqueId) {
        return Promise.reject(new Error("classroomUniqueId is required"));
      }
      return api().post<RegenerateCodeResponse>(
        ApiCatalog.classroomRegenerateCode.endpoint,
        {},
        {
          urlReplacers: [{ id: classroomUniqueId }],
        },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: userClassroomsQueries.all(),
      });
    },
  });

  return {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    generateCode: classroomUniqueId ? mutate : () => {},
    isPending,
    isError,
    error: error ?? null,
    classCode: data?.class_code ?? existingClassCode,
  };
};

export default useGenerateClassCode;
